var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStocktwits = function SvgStocktwits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.5L12 13.1l-6.5 6.5-1.1-1.1 6.5-6.5-6.4-6.5 1.1-1.1 6.5 6.5 6.5-6.5 1.1 1.1-6.6 6.5 6.5 6.5-1.1 1z"
  })));
};
export { SvgStocktwits as ReactComponent };